/**
 * ComingSoonPage — placeholder pour les routes pas encore implementees.
 *
 * Affichee par le catch-all `<Route path="*">` quand la sidebar liste une
 * section dont le sprint dedie n'a pas encore livre. Donne la vraie
 * photographie du produit a l'utilisateur sans casser la navigation.
 */
import { useLocation } from 'react-router'

import Page from '@/components/layout/Page'
import { NAV_ITEMS } from '@/config/navigation'

export default function ComingSoonPage() {
  const location = useLocation()
  const matched = NAV_ITEMS.find((item) => item.path === location.pathname)
  const sectionLabel = matched?.label ?? 'Cette section'
  const sprint = matched?.enableIn

  return (
    <Page width="narrow">
      <Page.Header
        eyebrow="Bientôt disponible"
        title={sectionLabel}
        subtitle={
          sprint
            ? `Cette section sera activée au sprint ${sprint}.`
            : 'Cette section arrivera dans un prochain sprint.'
        }
      />
    </Page>
  )
}
